import axios from 'axios';

axios.defaults.headers.common['x-apiToken'] =  process.env.REACT_APP_API_TOKEN

export default axios.create({
    baseURL: process.env.REACT_APP_COLD_SMTP_API_SERVER
    
  });
  